import {createTheme} from "@mui/material/styles";
import '../index.css'
const Theme = createTheme({
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    fontFamily: 'Vazir',
                    fontSize: "62.5%",
                    padding: 0,
                    margin: 0,
                    boxSizing: "border-box",
                    direction:'rtl'
                },
                body: {
                    backgroundColor: "#f1f1f4",
                    a: {
                        textDecoration: "none",
                        fontSize: "1.3rem",
                    },
                    label: {
                        fontSize: "1.6rem",
                        fontWeight: 500,
                    },
                    stronge: {
                        fontSize: "2.2rem",
                    },
                },
            },
        },
    },
    palette: {
        white: '#fff',
        black: '#000',
        primary: {
            main: '#6069E7'
        },
        secondary: {
            main: '#D50D0D',
        },
        info: {
            light: '#F5F6F9',
            main: '#AEAEAE',
            dark: '#7D7C7C',
        },
    },


    breakpoints: {
        values: {
            xs: 0,
            xxs: 320,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
            xxl: 1440,
        },
    },
    typography: {
        fontFamily: 'Vazir',
        h1: {
            fontSize: "30px",
            fontWeight: 700,
        },
        h2: {
            fontSize: "24px",
        },
        h3: {
            fontSize: "20px",
        },
        h4: {
            fontSize: '18px'
        },
        h5: {
            fontSize: "16px",
        },
        h6: {
            fontSize: "14px",
        },
        subtitle1: {
            fontSize: "12px"
        },
        subtitle2: {
            fontSize: '10px'
        },
        body2:{
            fontSize:'8px'
        },
    },
});

export default Theme;